<template>
<div>
    <div class="col-xs-12 col-md-12 push">
      <div class="col-xs-12 push">
          
          <div class="col-xs-12 col-md-6 align-center">
            <h5>{{labelButton[actualLanguage]}}</h5>
          </div>
          <div class="col-xs-12 col-md-6">
            <label class="css-input switch switch-success">
            <input type="checkbox" checked v-model="flagReadByInvoiceData">
            <span></span>
            <h5 v-if="flagReadByInvoiceData">{{lableActivated[actualLanguage]}}</h5>
            <h5 v-else>{{lableNotActivated[actualLanguage]}}</h5>
          </label>
          </div>
      </div>

      <div class="col-xs-12 push">
        <div v-if="flagReadByInvoiceData" class="col-xs-12 col-md-12 push">
          <h6>{{labelSelectInvoicePeriod[actualLanguage]}}</h6>
          <select class="form-control align-center" @click="applyInvoiceDate()" v-model=selectedInvoiceIndex size="1">
              <option v-for="(invoice,index) in mainService.service_invoices" :value="index">{{invoice.dateStartStr}}   <--->   {{invoice.dateEndStr}}</option>
          </select>
        </div>

        <div class="col-xs-12 col-md-4">
          <div class="input-daterange form-group row">
              <div class="input-date-time-picker" >
                <date-picker
                    class="el-input__inner form-control"
                    v-model="visualisationDateStart"
                    type="date"
                    placeholder=""
                    clear-icon=""
                    format="yyyy-MM-dd"
                    value-format="timestamp"
                />
              </div>
          </div>
        </div>

        <div class="col-xs-12 col-md-4">
          <div class="input-daterange form-group row">
              <div class="input-date-time-picker" >
                <date-picker
                    class="el-input__inner form-control"
                    v-model="visualisationDateEnd"
                    type="date"
                    placeholder=""
                    clear-icon=""
                    format="yyyy-MM-dd"
                    value-format="timestamp"
                />
              </div>
          </div>
        </div>

        <div class="col-xs-12 col-md-4">
            <button  type="button" @click="readMainServiceGraphData()" class="btn btn-default align-right" name="buttonAddPlanItem">
              <i class="fa fa-gear fa-1x push-5-r "></i>{{ labelButtonReadGraph[actualLanguage] }}</button>
        </div>


      </div>


      <div v-if="flagGraphDataIsUpdating" class="col-xs-12 col-md-12">
        <spinner size="large"></spinner>
      </div>

      <div v-if="flagDisplayGraph" class="col-xs-12 push">

        <div class="col-xs-12 col-md-12">
          <div class="col-xs-12 col-md-9">

            <div class="table-responsive push">
                <table class="table table-striped table-vcenter">
                    <thead>
                        <tr>
                            <th class="text-center" style="width: 50%;">{{summaryTableColumn01[actualLanguage]}}</th>
                            <th class="text-center" style="width: 25%;">{{summaryTableColumn02[actualLanguage]}}</th>
                            <th class="text-center" style="width: 25%;">{{summaryTableColumn03[actualLanguage]}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for= "(sousService,index) in summary.subServices">
                            <td class="font-w600 text-center">
                              {{sousService.referenceName}}
                            </td>
                            <td class="font-w600 text-center">
                              {{sousService.pourcentage}} %
                            </td>
                            <td class="font-w600 text-center">
                              {{sousService.sumCost}} $
                            </td>
                        </tr>

                    </tbody>
                </table>

            </div>
          </div>

          <div class="col-xs-12 col-md-3 align-right">
            
            <h5 class="align-right">{{periodCost[actualLanguage]}} $</h5>
            <h1 class="align-right">{{summary.sumCosts}} $</h1>
          </div>

        </div>


        <div class="col-xs-12 col-md-12">
            <graph-apex-pies :GraphData="pieChartData" ></graph-apex-pies>
        </div>

        <div class="col-xs-12 col-md-12">
            <graph-apex-bars :GraphData="barChartDataMain1" ></graph-apex-bars>
        </div>

        <div class="col-xs-12 col-md-12">
            <graph-apex-bars :GraphData="barChartDataSub1" ></graph-apex-bars>
        </div>

        <div class="col-xs-12 col-md-12">
            <graph-apex-bars :GraphData="barChartDataSub2" ></graph-apex-bars>
        </div>

      </div>

    </div>

</div>

</template>


<script>

import Spinner from '@/components/Spinner'

import {mapState, mapActions, mapGetters} from 'vuex'
import { DatePicker, TimePicker, TimeSelect } from 'element-ui';
import moment from 'moment';

import GraphApexTimeline from './GraphApexTimeLine'
import GraphApexBars from './GraphApexBars'
import GraphApexPies from './GraphApexPies'

export default {
  name: 'GroupIndex',
  props: ['mainService'],

  data() {
    return {
      flagDisplayBanner : 0,
      flagDisplayDetail : 0,
      flagDisplayGraph : false,
      flagGraphDataIsUpdating : false,
      actualLanguage : "FR",
      flagReadByInvoiceData : false,

      labelButton: {FR: "Données selon les saisies de factures",
                    EN: 'Read data according to billing data'},
      lableActivated :  {FR: "Activé", EN: 'Enabled'},
      lableNotActivated :  {FR: "Désactivé", EN: 'Disabled'},

      invoiceColumn01: {FR: "Numéro de référence", EN: 'Reference number'},

      periodCost : {FR: "Coûts de la période", EN: 'Period costs'},
      summaryTableColumn01 : {FR: "Sous service", EN: 'Sub service'},
      summaryTableColumn02 : {FR: "Pourcentage", EN: 'Pourcentage'},
      summaryTableColumn03 : {FR: "Coûts", EN: 'Costs'},

      labelSelectInvoicePeriod: {FR: "Période de facturation", EN: 'Billing period'},
      visualisationDateStart : '',
      visualisationDateEnd : '',
      GraphData : [],
      selectedInvoiceIndex : 0,

      labelButtonReadGraph: {FR: "Actualiser les graphiques", EN: 'Refresh graphs'},
      summary : {'sumCosts':0,subServices:[]},
      pieChartData : {ChartTitle:{FR: 'Répartition des coûts pour la période sélectionnée', EN: 'Breakdown of costs for the selected period'},
                      Labels : [],
                      Data : []},

      barChartDataMain1 : {ChartTitle:{FR: 'Distribution des coûts journaliers du service principal ($)',
                           EN: 'Main service daily distribution of costs ($)'},
                      XData : [],
                      YData  : [],
                      Options:{Stacked:false,StackType:"none"}},


      barChartDataSub1 : {ChartTitle:{FR: 'Distribution des coûts par sous service',
                                     EN: 'Distribution of costs by sub-service'},
                      XData : [],
                      YData  : [],
                      Options:{Stacked:true,StackType:"normal"}},

      barChartDataSub2 : {ChartTitle:{FR: 'Répartition des coûts par jour', EN: 'Breakdown of costs per day'},
                      XData : [],
                      YData  : [],
                      Options:{Stacked:true,StackType:"100%"}},

    }
  },
  components: {
    Spinner,
    DatePicker,
    TimePicker,
    TimeSelect,
    GraphApexTimeline,
    GraphApexBars,
    GraphApexPies,
  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData','planTransactionData','actualBundle','parentContainer']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),


    applyInvoiceDate(){
      if(this.mainService.service_invoices.length > 0){
        this.visualisationDateStart = this.mainService.service_invoices[this.selectedInvoiceIndex].dateStart
        this.visualisationDateEnd = this.mainService.service_invoices[this.selectedInvoiceIndex].dateEnd
      }
      

    },

    readMainServiceGraphData(){
        this.flagDisplayGraph = false
        this.flagGraphDataIsUpdating = true
        var GraphReadPostAction = 'GetMainServiceGraphData'

        if (this.flagReadByInvoiceData){
          GraphReadPostAction = 'GetMainServiceGraphDataFromInvoices'
        }

        var requestData = {'postAction':GraphReadPostAction,
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer,
                          'mainServiceId':this.mainService.service_id,
                          'dateStart':this.visualisationDateStart,
                          'dateEnd':this.visualisationDateEnd}

        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response.data)
              this.flagGraphDataIsUpdating = false
            if(response.data.Code=='OK'){
                this.GraphData = response.data.GraphData
                this.summary = response.data.GraphData[0].summary
                this.pieChartData.Labels = response.data.GraphData[0].pieData.labels
                this.pieChartData.Data = response.data.GraphData[0].pieData.data

                this.barChartDataMain1.XData = response.data.GraphData[0].barData.mainXData
                this.barChartDataMain1.YData = response.data.GraphData[0].barData.mainYData

                this.barChartDataSub1.XData = response.data.GraphData[0].barData.subXData
                this.barChartDataSub1.YData = response.data.GraphData[0].barData.subYData

                this.barChartDataSub2.XData = response.data.GraphData[0].barData.subXData
                this.barChartDataSub2.YData = response.data.GraphData[0].barData.subYData

                this.flagDisplayGraph = true
                //console.log(this.MainServiceList)
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })

    },


    },

  mounted() {
    this.applyInvoiceDate()
    
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    var thisDayUnix = (Math.floor(moment().unix()/(24*3600)))*(24*3600)
    this.visualisationDateStart =((thisDayUnix-7*24*3600) * 1000)
    this.visualisationDateEnd = (thisDayUnix * 1000)

    this.readMainServiceGraphData()

  }
}
</script>





// WEBPACK FOOTER //
// MainServiceDisplayTabGraphs.vue?adac4de2